<div class="row" [formGroup]="group">
	<div class="col-xl-12 personalInformation" formGroupName="personalDetails">
		<div class="m-form__section m-form__section--first">
			<div class="m-form__heading">
				<h3 class="m-form__heading-title">
					Personal Information:
				</h3>
			</div>
<!--
			<div class="row padding-10">
				<div class="form-group m-form__group col-6">
					<div class="row">
						<label class="col-xl-4 col-lg-4 col-form-label">
							Enter Aadhaar Number:
							<span class="red">*</span>
						</label>
						<div class="col-xl-8 col-lg-8">
							<input type="text" class="form-control m-input" name="aadharNumber"  [(ngModel)]="aadharNumber" [ngModelOptions]="{standalone: true}"[disabled]="adharValidation.isAadhaarVerified?'true':null"placeholder="Enter Aadhaar Number" maxlength="12" onkeydown="javascript: return event.keyCode == 69 ? false : true">
							  <div [hidden]="aadharNumber.valid || aadharNumber.untouched">
                   <div *ngIf="aadharNumber.errors && aadharNumber.errors.required" class="alert alert-danger error-text">
                       Please Enter Number
                   </div>

               </div>
							<app-form-control-messages [control]="group.get('personalDetails').get('aadharNumber')" [name]="'Aadhaar Number'" [errorMessages]="{minlength: 'Aadhaar Number should have 12 digits',maxlength: 'Aadhaar Number should have 12 digits'}"></app-form-control-messages>
						</div>
					</div>
				</div>
					<div class="form-group m-form__group col-4 padding-0">
					<button href="javascript:0;" *ngIf="!adharValidation.isAadhaarVerified else verfied" (click)="aadharValidate()"  class="btn btn-next">
													<span>
														<span>
															Verify

														</span>
				</span>
				</button>
				<p style="color:blue" *ngIf="!adharValidation.isAadhaarVerified">Please verify your Aadhaar</p>
				<ng-template #verfied>
					<span style="color:green">Verified</span>
				</ng-template>
				</div>
				<div class="form-group m-form__group col-6 padding-0">
					<div class="row col-md-12">
						<label class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-form-label">
							Upload Aadhaar Proof Copy:
							<span class="red">*</span>
						</label>

						<div class="col-xl-8 col-lg-8 col-md-8 col-sm-12" style="padding-left:27px!important">
							<app-upload-file [formValue]="this.group.get('personalDetails').get('aadharDoc')" [value]="this.group.get('personalDetails').get('aadharDoc').value"
							 fileType="aadharDoc" [(localFile)]="localFileName.aadharDoc" [(localFileValue)]="localFileName.aadharDoc" info="only pdf, jpg, png, jpeg"></app-upload-file>
							<app-form-control-messages [control]="this.group.get('personalDetails').get('aadharDoc')" [name]="'Aadhaar Document'"></app-form-control-messages>
						</div>
					</div>
				</div>
			</div> -->

			<div class="row padding-10" >
				<div class="form-group m-form__group col-6">
					<div class="row">
						<label class="col-xl-4 col-lg-4 col-form-label">
							Candidate Full Name:
							<span class="red">*</span>
						</label>
						<div class="col-xl-8 col-lg-8">
							<div class='row'>

								<div class="col-6">
									<select class="form-control m-bootstrap-select m_selectpicker no-opacity" formControlName="namePrefix" (change)="selectPrefix(this.group.get('personalDetails').get('namePrefix').value)">
										<option value='' disabled>Enter Salutation</option>
										<option *ngFor="let namePrefix of namePrefixOptions" [value]="namePrefix">
											<small>{{namePrefix}}</small>
										</option>
									</select>
						<app-form-control-messages [control]="this.group.get('personalDetails').get('namePrefix')" [name]="'Salutation'"></app-form-control-messages>

								</div>
								<div class="col-6">
									<input type="text" name="firstName" class="form-control m-input" maxlength="100" value="" formControlName="firstName">
									<app-form-control-messages [control]="this.group.get('personalDetails').get('firstName')" [name]="'Candidate Full Name'"></app-form-control-messages>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="form-group m-form__group col-6 padding-0">
					<div class="row col-md-12">
						<label class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-form-label">
							Upload Profile Picture:
							<span class="red">*</span>
						</label>

						<div class="col-xl-8 col-lg-8 col-md-8 col-sm-12" style="max-width: 19em;margin-left: 12px;">
							<app-upload-file *ngIf="formLoaded" [formValue]="this.group.get('personalDetails').get('profilePicture')" [value]="currentUserInfo?.personalDetails?.profilePicture"
							 fileType="profilePic" [(localFile)]="localFileName.identityfile" [(localFileValue)]="localFileName.identityfile"
							 info="only jpg, png, jpeg"></app-upload-file>
							<app-form-control-messages [control]="this.group.get('personalDetails').get('profilePicture')" [name]="'Profile Pic'"></app-form-control-messages>
							<input type="hidden" formControlName="profilePicture" #fileInput>
							<!-- <app-upload-file [formValue]="" fileType="profilePic" info="only jpg, png, jpeg"></app-upload-file> -->
						</div>
					</div>
				</div>
			</div>

		<!--	<div class="row padding-10">
				<div class="form-group m-form__group col-6">
					<div class="row">
						<label class="col-xl-4 col-lg-4 col-form-label">
							Last Name:
						</label>
						<div class="col-xl-8 col-lg-8">
							<input type="text" name="name" class="form-control m-input" placeholder="Enter last name" formControlName="lastName">
							<app-form-control-messages [control]="group.get('personalDetails').get('lastName')" [name]="'Last Name'"></app-form-control-messages>
						</div>
					</div>
				</div>

			</div>-->

			<div class="row padding-10">
				<div class="form-group m-form__group col-6">
					<div class="row">
						<label class="col-xl-4 col-lg-4 col-form-label">
							Gender:
							<span class="red">*</span>
						</label>
						<div class="col-xl-8 col-lg-8">
							<select class="form-control m-bootstrap-select m_selectpicker no-opacity" formControlName="gender" title="Select your gender" >
								<option value="" disabled selected>Select Gender</option>
								<option *ngIf="this.group.get('personalDetails').get('namePrefix').value!='Ms.'&&this.group.get('personalDetails').get('namePrefix').value!='Mrs.'&&this.group.get('personalDetails').get('namePrefix').value!='Mx.'"
								 value="Male">Male</option>
								<option *ngIf="this.group.get('personalDetails').get('namePrefix').value!='Mr.'&&this.group.get('personalDetails').get('namePrefix').value!='Mx.'" value="Female">Female</option>
								<option value="Transgender" *ngIf="this.group.get('personalDetails').get('namePrefix').value!='Mrs.'">Transgender</option>
							</select>
							<app-form-control-messages [control]="group.get('personalDetails').get('gender')" [name]="'Gender'"></app-form-control-messages>
						</div>
					</div>
				</div>
				<div class="form-group m-form__group col-6 padding-0">
					<div class="row col-md-12">
						<label class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-form-label">
							Date Of Birth:
							<span class="red">*</span>
						</label>
						<div class="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<!-- <input type="text" class="form-control" (focusout)="setDOB($event)" formControlName="dob" placeholder="Pick your Date of Birth"
								id="dob" /> -->
							<!-- <app-date-picker [model]="dateObject" [dateId]="'dob'" (dateChanged)="onDateChange($event)"></app-date-picker> -->
							<!-- <div class="input-group date">
                                <input type="date" class="form-control m-input" placeholder="Pick your Date of Birth" id="date" formControlName="dob" />
                                <div class="input-group-append">
                                    <span class="input-group-text">
                                        <i class="la la-calendar"></i>
                                    </span>
                                </div>
							</div> -->
							<div class="input-group">
								<input type="text" readonly class="form-control" (focusout)="setDOB($event)" formControlName="dob" placeholder="Pick your Date of Birth"
								 id="dob" />
								<div class="input-group-append">
									<span class="input-group-text">
										<i class="la la-calendar"></i>
									</span>
								</div>
							</div>
							<app-form-control-messages [control]="group.get('personalDetails').get('dob')" [name]="'Date Of Birth'"></app-form-control-messages>
						</div>
					</div>
				</div>
			</div>
			<div class="row padding-10">
				<div class="form-group m-form__group col-12 ">
					<div class="row">
						<label class="col-xl-2 col-lg-2 col-form-label">
							Mother/Father/Guardian Name:
							<span class="red">*</span>
						</label>
						<!-- <div class="col-xl-8 col-lg-8"> -->
						<!-- <div class='row'> -->

						<div class="col-xl-2 col-lg-2">
							<select class="form-control m-bootstrap-select m_selectpicker no-opacity" formControlName="relationWithGuardian" title='Select Relation'>
								<option value="" disabled selected>Select Relation</option>
								<option *ngFor="let relationWithGuardian of relationWithGuardianOptions" [ngValue]="relationWithGuardian">
									{{relationWithGuardian}}
								</option>
							</select>
							<app-form-control-messages [control]="group.get('personalDetails').get('relationWithGuardian')" [name]="'Mother/Father/Guardian Name'"></app-form-control-messages>
						</div>
						<div class="col-xl-5 col-lg-5">
							<input type="text" name="name" maxlength="100" class="form-control m-input" placeholder="Enter name" formControlName="guardianName">
							<app-form-control-messages [control]="group.get('personalDetails').get('guardianName')" [name]="'Mother/Father/Guardian Name'"></app-form-control-messages>
						</div>
					</div>
					<!-- </div> -->
					<!-- </div> -->
					<!-- </div> -->
				</div>
				<div class="form-group m-form__group col-6 padding-0">
					<div class="row">

					</div>
				</div>
			</div>

			<div class="row padding-10">
				<div class="form-group m-form__group col-6">
					<div class="row">
						<label class="col-xl-4 col-lg-4 col-form-label">
							Alternate ID Type:
						</label>
						<div class="col-xl-8 col-lg-8">

							<select class="form-control m-bootstrap-select m_selectpicker no-opacity" formControlName="alternateIdType" onkeydown="javascript: return event.keyCode == 69 ? false : true">
								<option value="" disabled selected>Select Alternate ID Type</option>
								<option *ngFor="let alternateIdType of alternateIdTypeOptions" [ngValue]="alternateIdType">
									{{alternateIdType}}
								</option>
							</select>
						</div>
					</div>
				</div>

				<div class="form-group m-form__group col-6 padding-0">
					<div class="row">
						<label class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-form-label">
							Alternate ID Number:
						</label>
						<div class="col-xl-8 col-lg-8">
							<input type="text" name="name" class="form-control m-input" maxlength="20" placeholder="Enter Alternate ID Number" formControlName="alternateIdNumber">
							<app-form-control-messages [control]="group.get('personalDetails').get('alternateIdNumber')" [name]="'Alternate ID Number'"></app-form-control-messages>

						</div>

					</div>
				</div>

			</div>
			<div class="row padding-10">
				<div class="form-group m-form__group col-6">
					<div class='row'>
						<label class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-form-label">
							Upload ID Proof Copy:
						</label>

						<div class="col-xl-8 col-lg-8 col-md-8 col-sm-12" style="max-width: 19em;margin-left: 4px;">
							<app-upload-file  *ngIf="formLoaded"  [formValue]="this.group.get('personalDetails').get('alternateIdDoc')" [value]="this.group.get('personalDetails').get('alternateIdDoc').value"
							 fileType="alternateIdDoc" [(localFile)]="localFileName.alternateIdDoc" [(localFileValue)]="localFileName.alternateIdDoc"
							 info="only pdf, jpg, png, jpeg"></app-upload-file>
							<app-form-control-messages [control]="this.group.get('personalDetails').get('alternateIdDoc')" [name]="'ID Proof'"></app-form-control-messages>
						</div>
					</div>
				</div>
			</div>

			<!-- <div class="m-separator m-separator--dashed m-separator--lg"></div> -->
		</div>
		<div class="m-form__section m-form__section--first">
			<div class="row padding-10">
				<div class="form-group m-form__group col-6">
					<div class='row'>
						<label class="col-form-label col-lg-4 col-sm-12">
							Category:
							<span class="red">*</span>
						</label>
						<div class="col-lg-8 col-md-8 col-sm-12">
							<select class="form-control m-bootstrap-select m_selectpicker no-opacity" formControlName="caste" title="Select">
								<option value="" disabled selected>Select Category</option>
								<option *ngFor="let casteOption of casteOptions" [ngValue]="casteOption.name">
									{{casteOption.name}}
								</option>
							</select>
							<app-form-control-messages [control]="group.get('personalDetails').get('caste')" [name]="'Category'"></app-form-control-messages>
						</div>
					</div>
				</div>

				<div class="form-group m-form__group col-6 padding-0">
					<div class='row'>
						<label class="col-form-label col-lg-4 col-sm-12">
							Religion:
							<span class="red">*</span>
						</label>
						<div class="col-lg-8 col-md-8 col-sm-12">
							<select class="form-control m-bootstrap-select m_selectpicker no-opacity" formControlName="religion" title="Select">
								<option value="" disabled selected>Select Religion</option>
								<option *ngFor="let religionOption of religionOptions" [ngValue]="religionOption.name">
									{{religionOption.name}}
								</option>
							</select>
							<app-form-control-messages [control]="group.get('personalDetails').get('religion')" [name]="'Religion'"></app-form-control-messages>

						</div>
					</div>
				</div>
			</div>

			<div class="row padding-10">
				<div class="form-group m-form__group col-6">
					<div class='row'>
						<label class="col-form-label col-xl-4 col-lg-4 col-md-4 col-sm-4">
							Any Disability ?
							<span class="red">*</span>
						</label>
						<div class="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<select class="form-control m-bootstrap-select m_selectpicker no-opacity" title="Select" (change)="setDisabilityValidation(group.get('personalDetails').get('differentlyAbled').value)"
							 formControlName="differentlyAbled">
								<option value="" disabled selected>Select Disability</option>
								<option [ngValue]="true">Yes</option>
								<option [ngValue]="false">No</option>
							</select>
							<app-form-control-messages [control]="group.get('personalDetails').get('differentlyAbled')" [name]="'Disability'"></app-form-control-messages>
						</div>
					</div>
				</div>

				<div class="form-group m-form__group col-6 padding-0" *ngIf="group.get('personalDetails').get('differentlyAbled').value == true">
					<div class='row'>
						<label class="col-form-label col-xl-4 col-lg-4 col-md-4 col-sm-4">
							If yes,type of disability:
							<span class="red">*</span>
						</label>
						<div class="col-xl-8 col-lg-8 col-md-8 col-sm-12">
							<select class="form-control m-bootstrap-select m_selectpicker no-opacity" formControlName="disabilityCategory" title="Select type of Disability">
								<option value="" disabled selected>Select Type of Disability</option>
								<option *ngFor="let disabilityTypeOption of disabilityTypeOptions" [ngValue]="disabilityTypeOption.pwdDesc">
									{{disabilityTypeOption.pwdDesc}}
								</option>
							</select>
							<app-form-control-messages [control]="group.get('personalDetails').get('disabilityCategory')" [name]="'Type of Disability'"></app-form-control-messages>
						</div>
					</div>
				</div>
			</div>
			<div class="row padding-10">
				<div class="form-group m-form__group col-6" *ngIf="group.get('personalDetails').get('differentlyAbled').value == true">
					<div class='row'>
						<label class="col-form-label col-lg-4 col-sm-12">If yes,Upload Supporting Document:
							<span class="red">*</span>
						</label>
						<div class="col-lg-8 col-md-8 col-sm-12" style="max-width: 19em;margin-left: 12px;">
							<app-upload-file *ngIf="formLoaded"  [formValue]="this.group.get('personalDetails').get('disabilityDoc')" [value]="currentUserInfo?.personalDetails?.disabilityDoc"
							 fileType="disabilityDoc" [(localFile)]="localFileName.disabilityDoc" [(localFileValue)]="localFileName.disabilityDoc"
							 info="only pdf, jpg, png, jpeg"></app-upload-file>
							<input type="hidden" formControlName="disabilityDoc" #fileInput>
							<app-form-control-messages [control]="this.group.get('personalDetails').get('disabilityDoc')" [name]="'Disability Document'"></app-form-control-messages>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="m-separator m-separator--dashed m-separator--lg"></div> -->


	</div>
</div>
